/* RYNOR size chart dropdown (snippets/size-chart-dropdown.liquid).
   Moved out of the page in v43-speed: it used to run inline, in the middle of the product page, before the
   rest of the page could be read. Now it is cached and deferred, and one copy starts every size chart
   on the page (including ones the theme editor re-draws). The code inside rynorInitSizeChart is unchanged. */
(function () {
  if (window.__rynorSizeChartBooted) return;
  window.__rynorSizeChartBooted = true;

  function rynorInitSizeChart(root) {
          if (!root || root.dataset.scInit === '1') return;
          root.dataset.scInit = '1';

          var btn = root.querySelector('.sc__toggle');
          var panel = root.querySelector('.sc__panel');
          var panes = root.querySelectorAll('.sc__pane');

          function setPanelHeight() {
            if (!root.classList.contains('is-open')) return;
            panel.style.maxHeight = panel.scrollHeight + 'px';
          }

          function loadRingChartImages() {
            if (root.dataset.scImagesLoaded === '1') return;
            root.dataset.scImagesLoaded = '1';

            var imgs = root.querySelectorAll('.sc__pane img[data-src]');
            imgs.forEach(function (img, index) {
              var src = img.getAttribute('data-src');
              if (!src) return;

              if (index === 0) {
                img.setAttribute('fetchpriority', 'high');
              }

              img.setAttribute('src', src);
              img.removeAttribute('data-src');
            });
          }

          function openPanel() {
            loadRingChartImages();
            root.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
            panel.setAttribute('aria-hidden', 'false');
            panel.style.maxHeight = panel.scrollHeight + 'px';
          }

          function closePanel() {
            if (calcApi) calcApi.closeMenu(false);
            root.classList.remove('is-open');
            btn.setAttribute('aria-expanded', 'false');
            panel.setAttribute('aria-hidden', 'true');
            panel.style.maxHeight = '0px';
          }

          btn.addEventListener('pointerdown', function () {
            loadRingChartImages();
          }, { passive: true });

          btn.addEventListener('click', function () {
            var isOpen = root.classList.contains('is-open');
            if (isOpen) closePanel();
            else openPanel();
          });

          // Show the chart image for 'cm' (mm) or 'in'
          function showPane(unit) {
            panes.forEach(function (p) {
              var active = p.getAttribute('data-pane') === unit;
              p.classList.toggle('is-active', active);
              if (active) p.removeAttribute('hidden');
              else p.setAttribute('hidden', 'hidden');
            });
            setTimeout(setPanelHeight, 0);
          }

          // Old CM / INCHES tabs (only rendered when the calculator is switched off)
          var tabs = root.querySelectorAll('.sc__tab');
          tabs.forEach(function (t) {
            t.addEventListener('click', function () {
              tabs.forEach(function (x) {
                x.classList.toggle('is-active', x === t);
                x.setAttribute('aria-selected', x === t ? 'true' : 'false');
              });
              showPane(t.getAttribute('data-unit'));
            });
          });

          var calcEl = root.querySelector('[data-sc-calc]');
          var calcApi = calcEl ? initCalc(calcEl) : null;

          // Recalc height when images load
          var imgs = root.querySelectorAll('img');
          imgs.forEach(function (img) {
            img.addEventListener('load', function () {
              setPanelHeight();
            });
          });

          window.addEventListener('resize', function () {
            setPanelHeight();
          });

          /* ---------- Ring size calculator ---------- */
          function parseChart(raw) {
            var out = [];
            String(raw || '').split(/[\n;]+/).forEach(function (line) {
              var m = line.match(/^\s*([^=]+?)\s*=\s*([\d.,]+)\s*$/);
              if (!m) return;
              var c = parseFloat(m[2].replace(',', '.'));
              if (c > 0) out.push({ size: m[1].trim(), c: c });
            });
            return out.sort(function (a, b) { return a.c - b.c; });
          }

          function decode(s) {
            var d = document.createElement('textarea');
            d.innerHTML = String(s == null ? '' : s);
            return d.value;
          }

          function sub(s, token, value) {
            return String(s || '').split(token).join(value);
          }

          // "14", "Size 14", "14 " => "14" (so labels like "Size 14" still match the chart)
          function norm(v) {
            var s = String(v == null ? '' : v).trim().toLowerCase();
            var m = s.match(/^\D*?(\d+(?:[.,]\d+)?)\D*$/);
            return m ? m[1].replace(',', '.') : s;
          }

          function initCalc(el) {
            var cfg = {};
            try { cfg = JSON.parse(el.querySelector('[data-sc-cfg]').textContent || '{}'); } catch (e) {}

            var T = {};
            var rawT = cfg.t || {};
            Object.keys(rawT).forEach(function (k) { T[k] = decode(rawT[k]); });

            var chart = parseChart(cfg.chart);
            if (!chart.length) chart = parseChart('8=48;10=50;12=52;14=54;16=56;18=58;20=60;22=62;24=64');
            var chartSizes = chart.map(function (r) { return norm(r.size); });
            var formId = cfg.formId || '';

            var TOL = 0.5;            // within half a millimetre counts as that size; more goes up one size
            var LOW = 40, HIGH = 76;  // realistic finger circumference range (mm), used to catch mix-ups

            var modeWrap = el.querySelector('[data-sc-mode-wrap]');
            var modeBtn = el.querySelector('[data-sc-mode-btn]');
            var modeLabel = el.querySelector('[data-sc-mode-text]');
            var menu = el.querySelector('[data-sc-menu]');
            var opts = Array.prototype.slice.call(el.querySelectorAll('[data-sc-opt]'));
            var activeIdx = 0;
            var input = el.querySelector('[data-sc-input]');
            var res = el.querySelector('[data-sc-res]');
            var resV = el.querySelector('[data-sc-res-v]');
            var pick = el.querySelector('[data-sc-pick]');
            var unitBtns = el.querySelectorAll('[data-sc-unit]');

            var st = { mode: 'ring', unit: 'mm', last: null, timer: 0 };

            var DEC = '.';
            try {
              if ((1.5).toLocaleString(document.documentElement.lang || undefined).indexOf(',') > -1) DEC = ',';
            } catch (e) {}

            function num(x, d) {
              var s = x.toFixed(d);
              if (s.indexOf('.') > -1) s = s.replace(/\.?0+$/, '');
              return s.replace('.', DEC);
            }

            function unitText(u) { return u === 'in' ? (T['in'] || 'in') : (T.mm || 'mm'); }
            function modeText(m, u) { return sub(m === 'finger' ? T.circumference : T.diameter, '%u', unitText(u)); }

            // circumference in mm for a typed value
            function circ(v, m, u) {
              var mm = u === 'in' ? v * 25.4 : v;
              return m === 'finger' ? mm : mm * Math.PI;
            }

            function plausible(c) { return c >= LOW && c <= HIGH; }

            // Accepts 17.8 / 17,8 / 5/8 / 2 1/8, with or without mm, cm, in or "
            function parse(raw) {
              var s = String(raw || '').toLowerCase().trim();
              if (!s) return null;
              var unit = null;
              var u = s.match(/\s*(mm|cm|inches|inch|in|"|\u201d|\u2033)\.?$/);
              if (u) {
                unit = u[1] === 'mm' ? 'mm' : (u[1] === 'cm' ? 'cm' : 'in');
                s = s.slice(0, u.index).trim();
              }
              s = s.replace(/,/g, '.');
              var v = NaN, f;
              if (/^\d*\.?\d+$/.test(s) || /^\d+\.$/.test(s)) v = parseFloat(s);
              else if ((f = s.match(/^(?:(\d+)[\s-]+)?(\d+)\s*\/\s*(\d+)$/)) && +f[3] > 0) v = (f[1] ? +f[1] : 0) + (+f[2]) / (+f[3]);
              if (!(v > 0)) return null;
              if (unit === 'cm') { v = v * 10; unit = 'mm'; }
              return { v: v, unit: unit };
            }

            function lookup(c) {
              var first = chart[0], last = chart[chart.length - 1];
              var step = chart.length > 1 ? chart[1].c - first.c : 2;
              if (c < first.c - step) return { msg: sub(T.smaller, '%s', first.size) };
              if (c > last.c + TOL) return { msg: sub(T.larger, '%s', last.size) };
              for (var i = 0; i < chart.length; i++) {
                if (chart[i].c >= c - TOL) return { size: chart[i].size };
              }
              return {};
            }

            // Typed something that only makes sense as the other measurement or unit? Use that.
            function guess(v, lockUnit) {
              var modes = [st.mode, st.mode === 'ring' ? 'finger' : 'ring'];
              var units = lockUnit ? [st.unit] : [st.unit, st.unit === 'mm' ? 'in' : 'mm'];
              for (var i = 0; i < units.length; i++) {
                for (var j = 0; j < modes.length; j++) {
                  if (plausible(circ(v, modes[j], units[i]))) return { mode: modes[j], unit: units[i] };
                }
              }
              return null;
            }

            // The product's own size swatch (or dropdown option) for a size, if it sells that size
            function findChoice(size) {
              if (!formId || size == null) return null;
              var want = norm(size);
              function inChart(v) { return chartSizes.indexOf(norm(v)) > -1; }

              var radios = document.querySelectorAll('input.swatches__form--input[form="' + formId + '"]');
              var groups = {}, order = [];
              radios.forEach(function (r) {
                var key = r.getAttribute('data-position') || r.name;
                if (!groups[key]) { groups[key] = []; order.push(key); }
                groups[key].push(r);
              });
              for (var g = 0; g < order.length; g++) {
                var list = groups[order[g]];
                if (!list.every(function (r) { return inChart(r.value); })) continue;
                var hit = list.filter(function (r) { return norm(r.value) === want; })[0];
                if (!hit) return null;
                return {
                  on: hit.checked,
                  choose: function () { if (!hit.checked) hit.click(); }
                };
              }

              var selects = document.querySelectorAll('select.js-variant-selector[form="' + formId + '"]');
              for (var s = 0; s < selects.length; s++) {
                var dd = selects[s];
                var opts = Array.prototype.slice.call(dd.options);
                if (!opts.length || !opts.every(function (o) { return inChart(o.value); })) continue;
                var opt = opts.filter(function (o) { return norm(o.value) === want; })[0];
                if (!opt) return null;
                return {
                  on: dd.value === opt.value,
                  choose: function () {
                    if (dd.value === opt.value) return;
                    dd.value = opt.value;
                    dd.dispatchEvent(new Event('change', { bubbles: true }));
                  }
                };
              }
              return null;
            }

            function render(r) {
              st.last = r || {};
              var size = st.last.size || null;
              var choice = size ? findChoice(size) : null;

              if (choice) {
                res.hidden = true;
                pick.hidden = false;
                pick.textContent = sub(choice.on ? T.selected : T.use, '%s', size);
                pick.classList.toggle('is-on', choice.on);
              } else {
                pick.hidden = true;
                res.hidden = false;
                res.classList.toggle('is-msg', !!st.last.msg);
                res.classList.toggle('is-val', !!size);
                resV.textContent = st.last.msg || size || '\u2014';
              }
            }

            function paint() {
              modeLabel.textContent = modeText(st.mode, st.unit);
              opts.forEach(function (o) {
                var m = o.getAttribute('data-sc-opt');
                var title = o.querySelector('[data-sc-opt-title]');
                if (title) title.textContent = modeText(m, st.unit);
                o.setAttribute('aria-selected', m === st.mode ? 'true' : 'false');
              });
              input.setAttribute('aria-label', modeText(st.mode, st.unit));
              var mid = chart[Math.floor((chart.length - 1) / 2)];
              var ex = st.mode === 'finger' ? mid.c : mid.c / Math.PI;
              input.placeholder = sub(T.example, '%v', st.unit === 'in' ? num(ex / 25.4, 2) : num(ex, 1));
              unitBtns.forEach(function (b) {
                b.setAttribute('aria-pressed', b.getAttribute('data-sc-unit') === st.unit ? 'true' : 'false');
              });
            }

            // Shopper switched the dropdown or MM / IN themselves: rewrite a valid number so the
            // size stays the same (17.2 mm ring = 54 mm finger = 0.677 in). A number that didn't
            // make sense before is kept as typed, since they're probably fixing a mix-up.
            function retarget(m2, u2) {
              var p = parse(input.value);
              if (!p) return;
              var c = circ(p.v, st.mode, p.unit || st.unit);
              if (!plausible(c) && !p.unit) return;
              var mm = m2 === 'finger' ? c : c / Math.PI;
              input.value = u2 === 'in' ? num(mm / 25.4, 3) : num(mm, 1);
            }

            function setMode(m, quiet) {
              m = m === 'finger' ? 'finger' : 'ring';
              if (m === st.mode) return;
              if (!quiet) retarget(m, st.unit);
              st.mode = m;
              paint();
              if (!quiet) run(false, true);
            }

            function setUnit(u, quiet) {
              u = u === 'in' ? 'in' : 'mm';
              if (u === st.unit) return;
              if (!quiet) retarget(st.mode, u);
              st.unit = u;
              paint();
              showPane(u === 'in' ? 'in' : 'cm');
              if (!quiet) run(false, true);
            }

            // settle: the shopper stopped typing; noGuess: they just changed a control themselves
            function run(settle, noGuess) {
              clearTimeout(st.timer);
              var p = parse(input.value);
              if (!p) { render({}); return; }

              if (p.unit && p.unit !== st.unit) setUnit(p.unit, true);

              var c = circ(p.v, st.mode, st.unit);
              if (plausible(c) || noGuess) { render(lookup(c)); return; }

              if (!settle) {
                render({});
                st.timer = setTimeout(function () { run(true); }, 700);
                return;
              }

              var g = guess(p.v, !!p.unit);
              if (g) {
                setMode(g.mode, true);
                setUnit(g.unit, true);
                c = circ(p.v, st.mode, st.unit);
              }
              render(lookup(c));
            }

            // ----- "What are you measuring?" menu -----
            function menuOpen() { return modeWrap.classList.contains('is-open'); }

            function setActive(i) {
              activeIdx = Math.max(0, Math.min(opts.length - 1, i));
              opts.forEach(function (o, j) { o.classList.toggle('is-active', j === activeIdx); });
              menu.setAttribute('aria-activedescendant', opts[activeIdx].id);
            }

            function openMenu() {
              if (menuOpen()) return;
              modeWrap.classList.add('is-open');
              modeBtn.setAttribute('aria-expanded', 'true');
              setActive(st.mode === 'finger' ? 1 : 0);
              try { menu.focus({ preventScroll: true }); } catch (e) { menu.focus(); }
            }

            function closeMenu(refocus) {
              if (!menuOpen()) return;
              modeWrap.classList.remove('is-open');
              modeBtn.setAttribute('aria-expanded', 'false');
              menu.removeAttribute('aria-activedescendant');
              opts.forEach(function (o) { o.classList.remove('is-active'); });
              if (refocus) {
                try { modeBtn.focus({ preventScroll: true }); } catch (e) { modeBtn.focus(); }
              }
            }

            function choose(i) {
              var m = opts[i] ? opts[i].getAttribute('data-sc-opt') : null;
              closeMenu(true);
              if (m) setMode(m);
            }

            modeBtn.addEventListener('click', function () {
              if (menuOpen()) closeMenu(false);
              else openMenu();
            });

            modeBtn.addEventListener('keydown', function (e) {
              if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                e.preventDefault();
                openMenu();
              }
            });

            menu.addEventListener('keydown', function (e) {
              var k = e.key;
              if (k === 'ArrowDown' || k === 'Down') { e.preventDefault(); setActive(activeIdx + 1); }
              else if (k === 'ArrowUp' || k === 'Up') { e.preventDefault(); setActive(activeIdx - 1); }
              else if (k === 'Home') { e.preventDefault(); setActive(0); }
              else if (k === 'End') { e.preventDefault(); setActive(opts.length - 1); }
              else if (k === 'Enter' || k === ' ' || k === 'Spacebar') { e.preventDefault(); choose(activeIdx); }
              else if (k === 'Escape' || k === 'Esc') { e.preventDefault(); e.stopPropagation(); closeMenu(true); }
              else if (k === 'Tab') { closeMenu(false); }
            });

            opts.forEach(function (o, i) {
              o.addEventListener('mousemove', function () { if (activeIdx !== i) setActive(i); });
              o.addEventListener('click', function () { choose(i); });
            });

            // Close when tapping or tabbing anywhere else
            document.addEventListener('pointerdown', function (e) {
              if (menuOpen() && !modeWrap.contains(e.target)) closeMenu(false);
            }, true);

            modeWrap.addEventListener('focusout', function (e) {
              if (e.relatedTarget && !modeWrap.contains(e.relatedTarget)) closeMenu(false);
            });

            unitBtns.forEach(function (b) {
              b.addEventListener('click', function () { setUnit(b.getAttribute('data-sc-unit')); });
            });

            input.addEventListener('input', function () { run(false); });
            input.addEventListener('change', function () { run(true); });
            input.addEventListener('keydown', function (e) {
              if (e.key === 'Enter') {
                e.preventDefault();
                run(true);
                input.blur();
              }
            });

            pick.addEventListener('click', function () {
              var choice = st.last && st.last.size ? findChoice(st.last.size) : null;
              if (choice) choice.choose();
              render(st.last);
            });

            // Keep "Select size" / "Size selected" in sync when the size is changed up top
            document.addEventListener('change', function (e) {
              var t = e.target;
              if (!formId || !t || !t.getAttribute || t.getAttribute('form') !== formId) return;
              if (st.last && st.last.size) render(st.last);
            });

            paint();
            render({});

            return { closeMenu: closeMenu };
          }
      
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-sc]');
    for (var i = 0; i < roots.length; i++) rynorInitSizeChart(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
